module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAABIElEQVRYR+2WTQ4BQRCFX7eEC3AMCeewEa7DiusQG+cgcQwuQKJHWkwymeBV1UzoRc+2pqq+fvXT7ZDY5xLjQQZiFckKZYWYAswu6qHBcLooOv5wOW73LOA7e380m7h7GJ9PuzXzp0BPGIcVgCu8n2uhIgxC2ADouQJLBkWBqgG1UBZfChQltgS2+MRcIiAtlBVGBSSFagKjBmJQTWFMQJ+gnuP8miZt81dXgbiH6vujqkYB3F6n6zaBMStUwkWoIoStAyIIIpjzfqbdVa0oVJYuGaCkSvZumv7W1N9G++djL0ko+efbjS8ee00izb91OBGQJYHFR7SHrIHZNfOpbFSh5B5o8SRJPWHZG7htOy1Z2wlZvAyUFWIKMHvuIabQA1beFjTx6R6NAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/layouts/HomeLayout/assets/icon-close.png
// module id = 150
// module chunks = 15